<template>
    <div class="row">
        <Main class="col-md-9 pr-0"></Main>
    </div>
</template>

<script>
    import Main from '@/components/main_page/sub_components/collect_main.vue'

    export default {
        name: "collect",
        components: {
            Main,
        },
    }
</script>

<style scoped>

</style>